export default __webpack_public_path__ + "static/media/green-suo.79e35367.svg";